import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanCreateMolinaUsers = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const createPermissionAll: UserPermission = {
    resource: 'molinausers',
    action: 'createbasic',
    scope: 'all',
  };

  const canCreateAll = useHasPermission(user, createPermissionAll);
  return canCreateAll;
};
